export const images = {
  hero: "https://cdn.magicpatterns.com/patterns/generated-images/c48b38ac-53f9-462f-a2cb-3743941eacd1.jpg",
  heroPortrait: "https://cdn.magicpatterns.com/patterns/generated-images/eaf3527b-f67c-4238-bbd6-45cc3a9d8268.jpg",
  editorial: "https://cdn.magicpatterns.com/patterns/generated-images/9a33e81d-ddbc-4130-8c42-e10f5c8ccd30.jpg",
  about: "https://cdn.magicpatterns.com/patterns/generated-images/eb24dbbe-7d3e-4d02-972c-5a18cf384482.jpg",
  processConsult: "https://cdn.magicpatterns.com/patterns/generated-images/ef9d07b9-0824-4020-8301-15a1d4efb75c.jpg",
};
